import React from 'react';
import { slideWrapper } from '../components/slide';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Timer } from '../components/timer';
import { Content } from '../components/content';
import { useAnimationSteps } from '@disco/hooks';
import { SlideImage } from '../components/slide-image';
import { useConfirmation } from '../../generic/hooks/use-confirmation';

export const LeonardoPuzzle3 = slideWrapper(({ step, data, getImg, ...props }) => {
  const { answers } = step;

  const animationStep = useAnimationSteps(1, true);

  const ConfirmationPopup = useConfirmation(1);
  return (
    <>
      <ConfirmationPopup />
      <Content left={14} top={-15} yNotCenter>
        <SlideImage width="400px" src={getImg('element')} show={animationStep} />
      </Content>
      <Content left={13} top={15} yNotCenter>
        <SlideImage width="300px" src={getImg('stojak')} show={true} />
      </Content>
      <Timer data={data} presentation />
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letter="a" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="b" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="c" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="d" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="e" answers={answers} smallItem />
      </PuzzleItemsWrapper>
    </>
  );
});
